import { Layout } from '@lm/common-ui'
import { lazy } from 'react'
import { Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom'

import { useAuth } from '@/hooks/useAuth'

import { paths } from './paths'

const Home = lazy(() => import('@/pages/Home'))
const Login = lazy(() => import('@/pages/Login'))

const PageLayout = () => (
  <Layout.Page>
    <Outlet />
  </Layout.Page>
)

const RequireAuth = () => {
  const { authenticated } = useAuth()
  const location = useLocation()

  if (!authenticated) {
    return (
      <Navigate to={paths.login} replace state={{ from: location.pathname }} />
    )
  }

  return <Outlet />
}

const RedirectIfAuthenticated = () => {
  const { authenticated } = useAuth()
  const location = useLocation()

  if (authenticated) {
    const from =
      (location.state as { from?: string } | null)?.from || paths.index
    return <Navigate to={from} replace />
  }

  return <Outlet />
}

export const AppRoutes = () => (
  <Routes>
    <Route element={<PageLayout />}>
      <Route element={<RequireAuth />}>
        <Route path={paths.index} element={<Home />} />
      </Route>
      <Route element={<RedirectIfAuthenticated />}>
        <Route path={paths.login} element={<Login />} />
      </Route>
    </Route>
  </Routes>
)
